/*
 * YumeFeel v18 buy-state controller (lane D1).
 * Active only inside an element carrying [data-yf-buy] (main-product with the
 * "YumeFeel buy states" setting on). Every other variant picker, quick add and
 * card form keeps the vendor behaviour below unchanged.
 * States: choose, pending, ready, adding, added, unavailable.
 */
(function () {
  if (window.YfBuy) return;
  const ROOT = "[data-yf-buy]";
  const registry = new WeakMap();

  // Same output as Liquid money_without_trailing_zeros: whole amounts drop ".00" ($649), others keep cents ($129.99).
  function formatMoney(cents, format) {
    const fmt = format || "${{amount}}";
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const n = typeof cents === "string" ? parseInt(cents.replace(/[^0-9-]/g, ""), 10) : cents;
    function delim(num, precision, thousands, decimal) {
      if (num == null || isNaN(num)) return "0";
      if (num % 100 === 0) precision = 0;
      const parts = (num / 100).toFixed(precision).split(".");
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return whole + (parts[1] ? decimal + parts[1] : "");
    }
    const m = fmt.match(re);
    if (!m) return fmt;
    let v;
    switch (m[1]) {
      case "amount_no_decimals": v = delim(n, 0, ",", "."); break;
      case "amount_with_comma_separator": v = delim(n, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": v = delim(n, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": v = delim(n, 2, "'", "."); break;
      default: v = delim(n, 2, ",", ".");
    }
    return fmt.replace(re, v);
  }

  /*
   * Sprint 1B (2026-09-28): one painter for every theme price box (snippets/price.liquid): ~~compare~~ price and the
   * quiet "Save $X" tag. Grey strike, never a % or Sale badge. opts: { text } overrides the price text ("From $849"),
   * { label } prefixes the package name, { from } keeps the "From" word.
   */
  function paintPrice(root, price, compare, format, opts) {
    if (!root || price == null) return;
    opts = opts || {};
    const money = (c) => formatMoney(c, format);
    const cmp = Number(compare) || 0;
    const sale = opts.text == null && cmp > Number(price);
    const boxes = root.classList && root.classList.contains("price") ? [root] : Array.from(root.querySelectorAll(".price"));
    boxes.forEach((p) => {
      p.querySelectorAll(".price__regular .price-item--regular, .price__sale .price-item--last").forEach((el) => {
        el.textContent = opts.text != null ? opts.text : money(price);
      });
      // Sprint 1B fix r1: the package name goes at the start of the box (read first by screen readers), never
      // inside the paid-price span, which sits after the strike and garbled the row ("~~$1,149~~ Cloud Sleep Set ·$899").
      if (opts.label) p.insertAdjacentHTML("afterbegin", opts.label);
      p.querySelectorAll(".yf-price__from").forEach((el) => { el.hidden = !opts.from; });
      p.classList.toggle("price--on-sale", sale);
      p.classList.toggle("yf-price--sale", sale);
      const ps = p.querySelector(".price__sale");
      if (ps) {
        if (sale) { if (!ps.classList.contains("visible-main-product")) ps.classList.add("visible"); }
        else ps.classList.remove("visible", "visible-main-product");
      }
      p.querySelectorAll(".price__sale s.price-item--regular").forEach((s) => {
        s.textContent = sale ? money(cmp) : "";
        s.classList.toggle("hidden", !sale);
      });
      p.querySelectorAll("[data-yf-save]").forEach((tag) => {
        tag.textContent = sale ? `Save ${money(cmp - Number(price))}` : "";
        tag.hidden = !sale;
      });
    });
  }

  // The yf-price-pair markup (<s data-was> / <span data-now> / [data-save]) painted in place, text only.
  function paintPair(el, price, compare, format, text) {
    if (!el) return;
    const money = (c) => formatMoney(c, format);
    const now = el.querySelector("[data-now]");
    if (!now) { el.textContent = text != null ? text : money(price); return; }
    now.textContent = text != null ? text : money(price);
    const cmp = Number(compare) || 0;
    const sale = text == null && cmp > Number(price);
    const was = el.querySelector("[data-was]");
    if (was) {
      was.hidden = !sale;
      const amt = was.querySelector("[data-was-amt]") || was;
      amt.textContent = sale ? money(cmp) : "";
    }
    el.querySelectorAll("[data-save]").forEach((s) => { s.hidden = !sale; s.textContent = sale ? `Save ${money(cmp - Number(price))}` : ""; });
    el.querySelectorAll(".yf-pp__from").forEach((f) => { f.hidden = true; });
  }

  class YfBuy {
    static rootFor(el) {
      if (!el || !el.closest) return null;
      const inside = el.closest(ROOT);
      if (inside) return inside;
      const holder = el.closest("[data-yf-for]");
      if (!holder) return null;
      const id = holder.getAttribute("data-yf-for");
      return (
        Array.from(document.querySelectorAll(ROOT)).find(
          (r) => r.getAttribute("data-yf-buy") === id && !r.closest(".wt__quick-buy"),
        ) || null
      );
    }

    static get(el) {
      const root = YfBuy.rootFor(el);
      if (!root) return null;
      let c = registry.get(root);
      if (!c) {
        c = new YfBuy(root);
        registry.set(root, c);
      }
      return c;
    }

    constructor(root) {
      this.root = root;
      this.id = root.getAttribute("data-yf-buy");
      this.isClone = !!root.closest(".wt__quick-buy");
      let cfg = {};
      try {
        cfg = JSON.parse(root.querySelector("script[data-yf-config]").textContent) || {};
      } catch (e) {}
      this.cfg = cfg;
      this.s = cfg.strings || {};
      this.state = root.getAttribute("data-yf-state") || "choose";
      this.variant = cfg.variant || null;
      this.timer = null;
      // Sprint 1 package target: this.variant stays the source of truth for size, this.target says which
      // package the buttons add (null = this product). See setTarget / resolvedTarget below.
      this.target = null;
      this.targets = {};
      if (typeof subscribe === "function") {
        subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => this.reconcileCart(cartData));
      }
    }

    reconcileCart(cart) {
      // Add responses are not a complete cart. Only a complete cart response can
      // establish that this selection was removed or replaced by an upgrade.
      if (!["added", "unconfirmed"].includes(this.state) || typeof cart?.item_count !== "number" || !Array.isArray(cart.items)) return;
      const want = (this.resolvedTarget() || {}).id || this.variant?.id;
      const present = cart.items.some((item) => String(item.variant_id || item.id) === String(want));
      if (this.state === "unconfirmed") {
        if (present) this.setState("added");
        // A timed-out POST can still settle server-side. Absence in one read is
        // not authorization to retry a purchase mutation automatically.
        return;
      }
      if (!present) {
        this.setState(this.variant?.available === false ? "unavailable" : "ready");
      }
    }

    scopes() {
      if (this.isClone) return [this.root];
      return [this.root].concat(
        Array.from(document.querySelectorAll(`[data-yf-for="${this.id}"]`)),
      );
    }

    all(selector) {
      const out = [];
      this.scopes().forEach((scope) => {
        if (scope !== this.root && scope.matches(selector)) out.push(scope);
        scope.querySelectorAll(selector).forEach((el) => out.push(el));
      });
      return out;
    }

    form() {
      return this.root.querySelector('form[data-type="add-to-cart-form"]');
    }

    options() {
      return Array.from(this.root.querySelectorAll("variant-options .wt-product__option"));
    }

    missingOption() {
      const missing = this.options().find((o) => !o.querySelector('input[type="radio"]:checked'));
      return missing ? missing.getAttribute("data-yf-option-name") || "" : null;
    }

    label(state) {
      const s = this.s;
      const v = this.variant;
      switch (state) {
        case "choose": {
          const name = this.missingOption() || s.defaultOption || "size";
          return (s.choose || "Choose [option]").replace("[option]", name.toLowerCase());
        }
        case "pending":
          return s.pending || "Updating…";
        case "adding":
          return s.adding || "Adding…";
        case "added": {
          const rt = this.resolvedTarget();
          let text = (s.added || "Added: [name] · [size]").replace("[name]", (rt && rt.id && rt.name) || this.cfg.name || "");
          const size = v && v.title && !this.cfg.singleVariant ? v.title : "";
          text = size ? text.replace("[size]", size) : text.replace(" · [size]", "").replace("[size]", "");
          return text;
        }
        case "unconfirmed":
          return "Check cart";
        case "unavailable":
          return s.unavailable || "This size is currently unavailable";
        default:
          return s.add || "Add to cart";
      }
    }

    setState(state, detail) {
      detail = detail || {};
      if (Object.prototype.hasOwnProperty.call(detail, "variant")) this.variant = detail.variant;
      clearTimeout(this.timer);
      this.state = state;
      this.root.setAttribute("data-yf-state", state);
      this.render();
      if (state === "added") {
        this.announce(this.label("added"));
        // Remain added until a different variant is selected. A second tap is
        // an intent to inspect the cart, not to purchase a duplicate set.
      }
      this.emit();
    }

    emit() {
      document.dispatchEvent(
        new CustomEvent("yf:buy", {
          detail: { id: this.id, state: this.state, variant: this.variant, clone: this.isClone, target: this.resolvedTarget() },
        }),
      );
    }

    /*
     * Sprint 1 (2026-09-28): package target. Additive; with no target every path behaves as before.
     *   registerTarget({ key, name, map: { <this variant id>: { id, price, compare, title } }, fromText, note })
     *   setTarget(key | target | null)   null = this product
     *   resolvedTarget() -> { key, id, price, name, title } for the chosen size ({ key, from: true } before a size)
     * The main form's formdata event swaps the posted id for the target's variant, so product-form.js (and the
     * AddToCart pixel event it triggers through window.fetch) sends the package the shopper chose.
     */
    registerTarget(t) {
      if (!t || !t.key || !t.map) return;
      this.targets[t.key] = t;
      this.bindFormData();
    }

    setTarget(t) {
      if (typeof t === "string") t = this.targets[t] || null;
      const prev = this.target ? this.target.key : null;
      this.target = t && t.map ? t : null;
      this.bindFormData();
      if ((this.target ? this.target.key : null) === prev) return this.render();
      if (this.state === "added") {
        return this.setState(this.variant && this.variant.available === false ? "unavailable" : "ready");
      }
      this.render();
      this.emit();
    }

    resolvedTarget() {
      const t = this.target;
      if (!t) return null;
      if (this.state === "choose" || !this.variant || !this.variant.id) {
        return { key: t.key, id: null, price: t.from != null ? t.from : null, name: t.name, from: true };
      }
      const m = t.map[String(this.variant.id)];
      if (!m || !m.id) return { key: t.key, id: null, price: null, name: t.name, missing: true };
      return { key: t.key, id: m.id, price: m.price, compare: m.compare || 0, name: t.name, title: m.title };
    }

    bindFormData() {
      if (this._fdBound || this.isClone) return;
      const form = this.form();
      if (!form) return;
      this._fdBound = true;
      form.addEventListener("formdata", (event) => {
        const rt = this.resolvedTarget();
        if (rt && rt.id && event.formData) event.formData.set("id", String(rt.id));
      });
    }

    targetText(el, text) {
      if (!el.hasAttribute("data-yf-orig")) el.setAttribute("data-yf-orig", el.innerHTML);
      el.textContent = text;
      el.setAttribute("data-yf-targeted", "");
    }

    untarget(el, text) {
      if (!el.hasAttribute("data-yf-targeted")) return;
      if (text != null) el.textContent = text;
      else if (el.hasAttribute("data-yf-orig")) el.innerHTML = el.getAttribute("data-yf-orig");
      el.removeAttribute("data-yf-targeted");
      el.removeAttribute("data-yf-orig");
    }

    /*
     * Fix round 1 (2026-09-28): the package's own price state in a theme price box. Never shows this product's
     * compare-at next to the package price: the strikethrough, sale class, sale badge and % badge follow the
     * package's compare-at (shown only when it is higher than its price) and are restored when the target goes.
     * The main box (not the sticky bar, which already swaps the name) also names the package: "Cloud Sleep Set · $849".
     */
    targetPrice(p, rt, priceText, chosen, named) {
      if (rt) {
        const sig = [priceText, rt.name, rt.compare || 0, rt.from ? 1 : 0, named ? 1 : 0].join("|");
        if (p.getAttribute("data-yf-sig") === sig && p.hasAttribute("data-yf-orig-price")) return;
        p.setAttribute("data-yf-sig", sig);
        if (!p.hasAttribute("data-yf-orig-price")) {
          p.setAttribute("data-yf-orig-price", p.innerHTML);
          p.setAttribute("data-yf-orig-cls", p.className);
        } else {
          p.innerHTML = p.getAttribute("data-yf-orig-price");
          p.className = p.getAttribute("data-yf-orig-cls");
        }
        // Sprint 1B fix r1: the package name is spoken, not shown. The stack's set row, the checked tile and the
        // Add button already name it on screen, and a visible label would change the price row's height.
        const label = named && rt.name ? `<span class="yf-price__pkg visually-hidden">${String(rt.name).replace(/[&<>"]/g, "")}: </span>` : "";
        paintPrice(p, rt.price, rt.from ? 0 : rt.compare || 0, this.cfg.moneyFormat, { label, text: rt.from ? priceText : null });
        p.setAttribute("data-yf-targeted", "");
      } else if (p.hasAttribute("data-yf-orig-price")) {
        p.innerHTML = p.getAttribute("data-yf-orig-price");
        p.className = p.getAttribute("data-yf-orig-cls");
        p.removeAttribute("data-yf-orig-price");
        p.removeAttribute("data-yf-orig-cls");
        p.removeAttribute("data-yf-targeted");
        p.removeAttribute("data-yf-sig");
        if (chosen && this.variant && this.variant.price != null) {
          paintPrice(p, this.variant.price, this.compareOf(this.variant), this.cfg.moneyFormat);
        }
      }
    }

    compareOf(v) {
      if (!v) return 0;
      return Number(v.compare_at_price != null ? v.compare_at_price : v.compare) || 0;
    }

    pair(el, price, compare, text) {
      paintPair(el, price, compare, this.cfg.moneyFormat, text);
    }

    renderTarget(chosen) {
      const rt = this.resolvedTarget();
      const live = rt && (rt.id || rt.from) && rt.price != null;
      const t = this.target;
      const priceText = live ? (rt.from ? t.fromText || this.money(rt.price) : this.money(rt.price)) : null;
      this.all("[data-yf-summary-name]").forEach((el) => {
        if (live) this.targetText(el, rt.name);
        else this.untarget(el);
      });
      ["price-", "sticky-price-"].forEach((prefix) => {
        const box = document.getElementById(prefix + this.id);
        if (!box) return;
        box.querySelectorAll(".price").forEach((p) => this.targetPrice(p, live ? rt : null, priceText, chosen, prefix === "price-"));
      });
      this.all("[data-yf-note]").forEach((el) => {
        if (live && t.note) this.targetText(el, t.note);
        else this.untarget(el);
      });
      this.all("[data-yf-card-price]").forEach((el) => {
        const m = live && t.map[el.getAttribute("data-yf-card-price")];
        if (m && m.price != null) {
          if (!el.hasAttribute("data-yf-orig")) el.setAttribute("data-yf-orig", el.innerHTML);
          this.pair(el, m.price, m.compare || 0);
          el.setAttribute("data-yf-targeted", "");
        } else this.untarget(el);
      });
      return live ? rt : null;
    }

    render() {
      const text = this.label(this.state);
      const blocked = !["ready", "choose", "added", "unconfirmed"].includes(this.state);
      // Sprint 1C fix r3: the sticky bar already shows the name, size and price, so its button keeps short words for
      // the passing states ("Updating…", "Adding…", "View cart"). With the sizer in its markup (sections/main-product)
      // the button never changes width, so an Add from the bar no longer squeezes the name or moves the bar.
      const short = { pending: this.s.stickyPending, adding: this.s.stickyAdding, added: this.s.stickyAdded }[this.state];
      this.all("[data-yf-buy-button]").forEach((b) => {
        const l = b.querySelector("[data-yf-label]");
        const t = short && b.getAttribute("data-yf-role") === "sticky" ? short : text;
        if (l && l.textContent !== t) l.textContent = t;
        b.setAttribute("data-yf-state", this.state);
        b.removeAttribute("disabled");
        if (blocked) b.setAttribute("aria-disabled", "true");
        else b.removeAttribute("aria-disabled");
      });
      const chosen = this.state !== "choose" && this.variant && this.variant.id;
      this.all("[data-yf-summary-size]").forEach((el) => {
        el.textContent = chosen && !this.cfg.singleVariant ? this.variant.title : "";
        el.hidden = !(chosen && !this.cfg.singleVariant);
      });
      const rt = this.renderTarget(chosen);
      this.all("[data-yf-summary-price]").forEach((el) => {
        if (!el.hasAttribute("data-yf-sum-orig")) el.setAttribute("data-yf-sum-orig", el.innerHTML);
        if (rt && rt.from) this.pair(el, rt.price, 0, this.target.fromText || this.money(rt.price));
        else if (rt) this.pair(el, rt.price, rt.compare || 0);
        else if (chosen && this.variant.price != null) this.pair(el, this.variant.price, this.compareOf(this.variant));
        else el.innerHTML = el.getAttribute("data-yf-sum-orig");
      });
      this.all("[data-yf-pick-value]").forEach((p) => {
        const input = this.findInput(p.dataset.yfPickPosition, p.dataset.yfPickValue);
        p.setAttribute("aria-pressed", input && input.checked ? "true" : "false");
      });
    }

    primary() {
      if (this.state === "added" || this.state === "unconfirmed") {
        const drawer = document.querySelector("cart-drawer");
        if (drawer && drawer.cartType !== "page" && !drawer.isCartPage) {
          drawer.setActiveElement(document.activeElement);
          if (!drawer.isOpen) drawer.toggleDrawerClasses();
        } else window.location.assign(window.routes.cart_url);
        return;
      }
      if (this.state === "choose") return this.focusPicker(true);
      if (this.state !== "ready") return;
      const form = this.form();
      if (!form) return;
      if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.dispatchEvent(new Event("submit", { cancelable: true }));
    }

    focusPicker(announce) {
      const opts = this.options();
      const target = opts.find((o) => !o.querySelector('input[type="radio"]:checked')) || opts[0];
      if (!target) return;
      const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target.scrollIntoView({ block: "center", behavior: reduce ? "auto" : "smooth" });
      const input =
        target.querySelector('input[type="radio"]:checked') ||
        target.querySelector('input[type="radio"]:not(.disabled)') ||
        target.querySelector('input[type="radio"]');
      if (input) input.focus({ preventScroll: true });
      target.classList.remove("yf-opt--nudge");
      void target.offsetWidth;
      target.classList.add("yf-opt--nudge");
      if (announce) {
        const name = (target.getAttribute("data-yf-option-name") || "size").toLowerCase();
        this.announce((this.s.announceChoose || "Choose your [option]").replace("[option]", name));
      }
    }

    announce(message) {
      const region = this.root.querySelector("[data-yf-live]");
      if (!region) return;
      region.textContent = "";
      setTimeout(() => {
        region.textContent = message;
      }, 60);
    }

    findInput(position, value) {
      return Array.from(
        this.root.querySelectorAll(`variant-options input[type="radio"][data-position="${position}"]`),
      ).find((i) => i.value === value);
    }

    pick(position, value) {
      const input = this.findInput(position, value);
      if (!input) return;
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      this.render();
    }

    money(cents) {
      return formatMoney(cents, this.cfg.moneyFormat);
    }
  }

  YfBuy.formatMoney = formatMoney;
  YfBuy.paintPrice = paintPrice;
  YfBuy.paintPair = paintPair;
  window.YfBuy = YfBuy;

  document.addEventListener("click", (event) => {
    const pickEl = event.target.closest && event.target.closest("[data-yf-pick-value]");
    if (pickEl) {
      const c = YfBuy.get(pickEl);
      if (c) {
        event.preventDefault();
        c.pick(pickEl.dataset.yfPickPosition, pickEl.dataset.yfPickValue);
      }
      return;
    }
    const btn = event.target.closest && event.target.closest("[data-yf-buy-button]");
    if (!btn || btn.getAttribute("data-yf-role") === "main") return;
    const c = YfBuy.get(btn);
    if (!c) return;
    event.preventDefault();
    c.primary();
  });
})();

if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );
      }

      connectedCallback() {
        this.isHighVariantsProduct = this.dataset.highVariantsProduct === "";
        this.toggleDisabledVariantOptions = this.toggleDisabledVariantOptions.bind(this);
        this._variantChangeRequestId = 0;
        this._variantFetchAbortController = null;
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {}

      get yf() {
        if (this._yf === undefined) {
          this._yf = window.YfBuy && this.closest("[data-yf-buy]") ? window.YfBuy.get(this) : null;
        }
        return this._yf;
      }

      initialize() {
        if (this.yf && !this.isHighVariantsProduct) {
          this.yfInitialize();
          return;
        }
        if (this.isHighVariantsProduct) {
          // High-variant: options/state are set on first selection via fetchVariant(); only sync gallery if we have initial variant.
          if (this.currentVariant) {
            this.updateGallery();
          }
        } else {
          this.updateOptions();
          this.updateMasterId();
          if (this.currentVariant) {
            this.updateGallery();
          }
          this.updateVariantStatuses();
          this.updateDropdownButtons();
        }
      }

      onKeyDown(event) {
        if (this.yf) return;
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
          // this.onVariantChange();
        }
      }

      yfInitialize() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        const radiosChecked = this.options.every((o) => o);
        const noneChecked = this.options.every((o) => !o);
        // Sprint 1B: ?variant= → the shopper's stored pick (this session) → the King default (data-yf-default).
        const stored = () => {
          if (this.dataset.updateUrl === "false" || this.yf.isClone) return null;
          try {
            if (new URLSearchParams(window.location.search).get("variant")) return null;
            return sessionStorage.getItem(`yf:variant:${this.dataset.productHandle}`);
          } catch (e) { return null; }
        };
        const applyStored = (restored) => {
          const variant = restored && this.getVariantData()?.find((v) => String(v.id) === String(restored));
          if (!variant || variant.available === false) return false;
          variant.options.forEach((value, index) => {
            const input = Array.from(
              this.querySelectorAll(`input[type="radio"][data-position="${index + 1}"]`),
            ).find((i) => i.value === value);
            if (input) input.checked = true;
          });
          this.yfVariantChange();
          return true;
        };
        if (radiosChecked && this.currentVariant) {
          if (this.querySelector('input[type="radio"][data-yf-default]:checked')) {
            const restored = stored();
            if (restored && String(restored) !== String(this.currentVariant.id) && applyStored(restored)) return;
          }
          // A valid ?variant= render, the default size, or radios restored by the browser: confirm the state.
          if (this.yf.state === "choose" || String(this.yf.variant?.id) !== String(this.currentVariant.id)) {
            this.yfVariantChange();
          } else if (this.currentVariant) {
            this.updateGallery();
          }
          return;
        }
        if (noneChecked) applyStored(stored());
      }

      yfVariantChange() {
        this.dispatchEvent(new CustomEvent("variantChangeStart", { bubbles: true, composed: true }));
        const yf = this.yf;
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        this.removeErrorMessage();
        const end = () =>
          this.dispatchEvent(new CustomEvent("variantChangeEnd", { bubbles: true, composed: true }));

        if (this.options.some((o) => !o)) {
          this._yfRequest = (this._yfRequest || 0) + 1;
          this._yfAbort?.abort();
          yf.setState("choose", { variant: null });
          end();
          return;
        }
        if (!this.currentVariant) {
          this._yfRequest = (this._yfRequest || 0) + 1;
          this._yfAbort?.abort();
          this.yfSetInputs("");
          yf.setState("unavailable", {
            variant: { id: null, title: this.options.join(" / "), price: null, available: false },
          });
          end();
          return;
        }
        const variant = this.currentVariant;
        this.updateGallery();
        this.updatePickupAvailability();
        this.updateMedia();
        if (document.querySelectorAll("variant-options").length === 1) this.updateURL();
        this.updateVariantInput();
        this.updateShareUrl();
        this.yfClientPrice(variant);
        yf.setState("pending", { variant });
        if (this.dataset.updateUrl !== "false" && !yf.isClone) {
          try {
            sessionStorage.setItem(`yf:variant:${this.dataset.productHandle}`, String(variant.id));
          } catch (e) {}
        }
        this.yfFetch(variant);
        end();
      }

      yfSetInputs(value) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}`)
          .forEach((form) => {
            const input = form.querySelector('input[name="id"]');
            if (input) input.value = value;
          });
      }

      yfClientPrice(variant) {
        if (!variant || variant.price == null || !window.YfBuy) return;
        [`price-${this.dataset.section}`, `sticky-price-${this.dataset.section}`].forEach((id) => {
          const root = document.getElementById(id);
          if (!root) return;
          root.classList.remove("visibility-hidden");
          window.YfBuy.paintPrice(root, variant.price, variant.compare_at_price, this.yf.cfg.moneyFormat);
        });
      }

      yfFetch(variant) {
        const requestId = (this._yfRequest = (this._yfRequest || 0) + 1);
        this._yfAbort?.abort();
        const controller = (this._yfAbort = new AbortController());
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const url = new URL(this.dataset.url || "", window.location.origin);
        url.searchParams.set("variant", variant.id);
        url.searchParams.set("section_id", sectionId);
        let settled = false;
        const settleFromClient = () => {
          if (settled || requestId !== this._yfRequest) return;
          settled = true;
          controller.abort();
          this.yf.setState(variant.available ? "ready" : "unavailable", { variant });
        };
        const timeout = setTimeout(settleFromClient, 4000);
        fetch(url.toString(), { signal: controller.signal })
          .then((response) => {
            if (!response.ok) throw new Error(`Variant section ${response.status}`);
            return response.text();
          })
          .then((text) => {
            if (settled || requestId !== this._yfRequest) return;
            settled = true;
            clearTimeout(timeout);
            const html = new DOMParser().parseFromString(text, "text/html");
            this.applyVariantUpdate(html);
            const button = html.getElementById(`ProductSubmitButton-${sectionId}`);
            const available =
              button && button.hasAttribute("data-yf-available")
                ? button.getAttribute("data-yf-available") === "true"
                : variant.available;
            this.yf.setState(available ? "ready" : "unavailable", {
              variant: Object.assign({}, variant, { available }),
            });
          })
          .catch((error) => {
            if (error && error.name === "AbortError") return;
            clearTimeout(timeout);
            settleFromClient();
          });
      }

      async onVariantChange() {
        if (this.yf && !this.isHighVariantsProduct) {
          this.yfVariantChange();
          return;
        }
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);
        this.toggleAddButton(true, "", false);
        if (this.isHighVariantsProduct) {
          // updateVariantStatuses/updateDropdownButtons are skipped: availability comes from server-rendered HTML (fetchVariant replaces innerHTML; product_option_value.available is used server-side).
          const requestId = ++this._variantChangeRequestId;
          this._variantFetchAbortController?.abort();
          this._variantFetchAbortController = new AbortController();
          const signal = this._variantFetchAbortController.signal;
          this.toggleDisabledVariantOptions(true);
          try {
            await this.fetchVariant(signal);
            if (requestId !== this._variantChangeRequestId) return;
            this.postVariantResolution(this.fetchedVariantHTML);
          } catch (e) {
            if (requestId !== this._variantChangeRequestId) return;
            console.error("Variant fetch failed:", e);
            this.toggleAddButton(true, "", true);
          } finally {
            this.toggleDisabledVariantOptions(false);
          }
        } else {
          this.updateOptions();
          this.updateMasterId();
          this.updateVariantStatuses();
          this.updateDropdownButtons();
          this.postVariantResolution(null);
        }
        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      toggleDisabledVariantOptions(isDisabled = true) {
        this.classList.toggle("wt-variant-options--disabled", isDisabled);
        this.setAttribute("aria-busy", isDisabled ? "true" : "false");
        this.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.disabled = isDisabled;
        });
      }

      /**
       * Shared sequence after variant is resolved: gallery, pickup, error clear,
       * then either unavailable UI or media/URL/input + product info + share URL.
       * @param {Document|null} htmlOrNull - If set, apply product info from this doc (high-variant path). If null, fetch section then apply (standard path).
       */
      postVariantResolution(htmlOrNull) {
        this.updateGallery();
        this.updatePickupAvailability();
        this.removeErrorMessage();
        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
          return;
        }
        this.updateMedia();
        this.lenOfVariantOptions =
          document.querySelectorAll("variant-options").length;
        if (this.lenOfVariantOptions === 1) {
          this.updateURL();
        }
        this.updateVariantInput();
        if (htmlOrNull) {
          this.applyVariantUpdate(htmlOrNull);
        } else {
          this.renderProductInfo();
        }
        this.updateShareUrl();
      }

      /**
       * Updates price, SKU, inventory, add-button state and publishes variantChange from a section HTML document.
       * Used by both renderProductInfo (after fetch) and renderProductInfoWithoutFetch (from fetchedVariantHTML).
       */
      applyVariantUpdate(html) {
        if (!html) return;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(`price-${sectionId}`);

        const stickyDestination = document.getElementById(`sticky-price-${this.dataset.section}`);
        const stickySource = html.getElementById(`sticky-price-${sectionId}`);

        const featuredDestination = document.getElementById(`sticky-image-${this.dataset.section}`);
        const featuredSource = html.getElementById(`sticky-image-${sectionId}`);

        const skuSource = html.getElementById(`Sku-${sectionId}`);
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(`Inventory-${sectionId}`);
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        if (source && destination) destination.innerHTML = source.innerHTML;

        if (stickySource && stickyDestination) {
          stickyDestination.innerHTML = stickySource.innerHTML;
        }
        if (featuredDestination && featuredSource) {
          const clone = featuredSource.cloneNode(true);
          featuredDestination.replaceWith(clone);
        }
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
        }

        const price = document.getElementById(
          `price-${this.dataset.section}`,
        );
        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource?.innerText === "",
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`,
        );
        this.toggleAddButton(
          addButtonUpdated
            ? addButtonUpdated.hasAttribute("disabled")
            : true,
          window.variantStrings?.soldOut,
        );

        const btnPriceSource = addButtonUpdated?.querySelector("wt-btn-price");
        const btnPriceDestination = document
          .getElementById(`ProductSubmitButton-${this.dataset.section}`)
          ?.querySelector("wt-btn-price");
        if (btnPriceSource && btnPriceDestination) {
          btnPriceDestination.textContent = btnPriceSource.textContent;
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: { sectionId, html, variant: this.currentVariant },
        });
      }

      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`,
        );

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        try{
          mediaGallery?.filterSlides(this.options, media_id, true);
        } catch (error) {}
      }

      updateDropdownButtons(){
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value || '';
        });

        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown",
          );
          if (dropdown) {
            const checkedInput = fieldset.querySelector('fieldset input:checked')
            if(!checkedInput) return
            const isInputDisabled = checkedInput?.classList.contains('disabled')
            dropdown.classList.toggle('wt-product__option__dropdown--unavailable', isInputDisabled)
          }
        });
      }

      async updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.value || ""
          );
        });

        this.checkedOptions = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          ) || '';
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index];
          if (this.yf) {
            const yfTitle = fieldset.querySelector(".wt-product__option__title");
            if (yfTitle) yfTitle.toggleAttribute("data-yf-chosen", !!selectedOption);
          }

          if (!selectedOption) return;

          // .value may be pre-filled by Liquid for SSR; we overwrite for client state
          fieldset.querySelector(
            ".wt-product__option__title .value",
          ).innerHTML = selectedOption;
          const dropdownSpan = fieldset.querySelector(
            ".wt-product__option__dropdown span",
          );
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      async fetchVariant(signal) {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.value || ""
          );
        });

        this.optionsWithIds = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.getAttribute("data-value-id") || ""
          );
        });
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;
        const url = new URL(this.dataset.url || "", window.location.origin);
        url.searchParams.set("option_values", this.optionsWithIds.join(","));
        url.searchParams.set("section_id", sectionId);
        const response = await fetch(url.toString(), { signal });
        if (!response.ok) {
          throw new Error(`Variant fetch failed: ${response.status}`);
        }
        const data = await response.text();
        if (signal?.aborted) return;
        const html = new DOMParser().parseFromString(data, "text/html");
        // For high-variants, response can be full page: scope to our section so featured product doesn't get main product's HTML
        const sectionEl = html.getElementById(`shopify-section-${sectionId}`);
        const variant = sectionEl
          ? sectionEl.querySelector("variant-options")
          : html.querySelector("variant-options");
        if (!variant) {
          throw new Error("Variant response: no variant-options element");
        }
        // Prevent re-triggering entry animations on swapped-in content
        variant
          .querySelectorAll(".scroll-trigger.animate--slide-in")
          .forEach((item) => item.classList.remove("animate--slide-in"));

        const selectedVariantScript = variant.querySelector(
          "[data-selected-variant]",
        );
        if (!selectedVariantScript) {
          throw new Error(
            "Variant response: no [data-selected-variant] script (no matching variant)",
          );
        }
        let selectedVariant = null;
        try {
          selectedVariant = JSON.parse(selectedVariantScript.textContent || "null");
        } catch (parseError) {
          throw new Error(
            "Variant response: invalid [data-selected-variant] JSON",
            { cause: parseError },
          );
        }
        if (signal?.aborted) return;
        this.currentVariant = selectedVariant;
        this.innerHTML = variant.innerHTML;
        this.fetchedVariantHTML = html;
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src,
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id,
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        const selectedUrl = new URL(window.location.href);
        selectedUrl.pathname = this.dataset.url;
        selectedUrl.searchParams.set("variant", this.currentVariant.id);
        window.history.replaceState(window.history.state, "", selectedUrl);
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        // const selectedOptionOneVariants = this.variantData.filter(
        //   (variant) => this.querySelector(':checked').value === variant.option1
        //   );
        const selectedOptionOneVariants = this.variantData?.filter(
          (variant) => variant.available === true,
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];

        const checkedInputs = [...this.querySelectorAll('.product-form__input :checked')]
        const checkedInputsValues = [...this.querySelectorAll('.product-form__input :checked')].map(input => input.getAttribute('value'))

        const previousSelectedOptions = []
        inputWrappers.forEach((option, index) => {
          if (index === 0 && inputWrappers.length > 1) return;

          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
          const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
          
            previousSelectedOptions.push(previousOptionSelected)

              const availableOptionInputsValue = selectedOptionOneVariants
              .filter(
                (variant) => {
                  if (index === 2){
                    return variant.available &&
                    variant[`option1`] === previousSelectedOptions[0] &&
                    variant[`option2`] === previousSelectedOptions[1]
                  } else {
                    return variant.available &&
                    variant[`option${index}`] === previousOptionSelected
                  }
                }
              )
              .map((variantOption) => variantOption[`option${index + 1}`]);
              this.setInputAvailability(optionInputs, availableOptionInputsValue, checkedInputsValues, index, checkedInputs);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions, checkedInputsValues, index, checkedInputs) {
        // helper function to check if array contains another array
        function containsSubarray(arr, subarr) {
          return arr.join(',').includes(subarr.join(','));
        }
        
        const checkedValues = checkedInputsValues.slice(0, index)

        const listOfAvailableVariants = this.getVariantData().filter((variant) => {
          if (containsSubarray(variant.options, checkedValues)) return true;
        });

        // For 3+ options: need all previous options (positions 1..index) to have a selection so listOfAvailableVariants is correct
        const isPreviousOptionChecked =
          index === 0 ||
          Array.from({ length: index }, (_, i) => i + 1).every((pos) =>
            checkedInputs.some((inp) => inp.dataset.position === String(pos)),
          );

        const hideUnavailableOptions = this.dataset.hideUnavailableOptions !== undefined;

        // Normalize option value for comparison (JSON may have number/string, getAttribute is string)
        const norm = (v) => String(v ?? "").trim();

        listOfOptions.forEach((input) => {
          if (!isPreviousOptionChecked) return;
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }

          // check if option exist. If not, it should be disabled (match by option position, not just includes)
          let inputOccurs = false;
          const inputValue = norm(input.getAttribute("value"));
          listOfAvailableVariants.forEach((variant) => {
            if (norm(variant.options[index]) === inputValue) {
              inputOccurs = true;
            }
          });

          if(!inputOccurs) input.classList.add("disabled");

          // Hide only options that don't exist (no variant); only for 2nd/3rd option, never first
          if (hideUnavailableOptions && index >= 1) {
            const listItem = input.closest("li");
            if (listItem) {
              if (!inputOccurs) {
                listItem.classList.add("wt-variant-option--hidden");
              } else {
                listItem.classList.remove("wt-variant-option--hidden");
              }
            }
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (typeof productForm?.handleErrorMessage !== "function") return;
        try {
          productForm.handleErrorMessage();
        } catch (err) {
          console.error(err);
        }
      }

      renderProductInfoWithoutFetch() {
        const requestedVariantId = this.currentVariant?.id;
        if (this.currentVariant?.id !== requestedVariantId) return;
        const html = this.fetchedVariantHTML;
        if (!html) return;
        this.applyVariantUpdate(html);
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;
        const url = new URL(this.dataset.url || "", window.location.origin);
        url.searchParams.set("variant", requestedVariantId);
        url.searchParams.set("section_id", sectionId);

        fetch(url.toString())
          .then((response) => response.text())
          .then((responseText) => {
            if (this.currentVariant?.id !== requestedVariantId) return;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.applyVariantUpdate(html);
          })
          .catch((error) => {
            console.error("Variant section fetch failed:", error);
            if (this.currentVariant?.id !== requestedVariantId) return;
            this.toggleAddButton(!this.currentVariant?.available, window.variantStrings?.soldOut);
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        if (this.yf) return;
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] .wt-btn__label span');
        if (!addButton || !addButtonText) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          const customLabel = addButton.getAttribute("data-custom-add-label");
          if (customLabel) {
            addButtonText.innerHTML = customLabel;
          } else {
            addButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");

        if (!button) return;
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] .wt-btn__label span');
        if (!addButton || !addButtonText) return;
        addButtonText.textContent = window.variantStrings.unavailable;

        const btnPrice = button.querySelector("wt-btn-price");
        if (btnPrice) btnPrice.textContent = "";
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );
        return this.variantData;
      }
    },
  );
}
// customElements.define('variant-options', VariantOptions);
